import { ItemSource } from './source-section.model';
import { Brand, LangCode, ProductVariant } from "@sgm-frontend/core";

export interface ProductInCartVariant {
  id: string;
  brand: Brand;
}

export interface ProductVariantGalleryInCart {
  image_thumbnail_url: string;
}

export interface ProductVariantTranslationInCart {
  __key: string;
  name: string;
}

export interface CartProductVariant { //need to be change when product response is finalised
  id: string;
  product_id: string;
  sale_price: number | null;
  regular_price: number;
  quantity_available: number;
  quantity_low: number;
  product: ProductInCartVariant;
  product_variant_gallery: ProductVariantGalleryInCart;
  translation: ProductVariantTranslationInCart;
}

export interface Cart {
  cart_items: CartItem[];
  stock_out : CartItem[];
  cart_count: number;
  sub_total: number;
  shipping_fee: number;
  discount: number;
  grand_total: number;
  coupon_code: string;
  shipping_method:ShippingMethodCart;
}
export interface ShippingMethodCart {
  id: string;
  name: string;
  method_code: string;    // e.g., "free", "express", "standard"
  min_cart_total: string; // better to store as number instead of string
}

export interface CartItem extends ItemSource {
  quantity: number;
  product_variant: ProductVariant;
  // product_variant: ProductVariant; //need to use when its finalised
}
